import axiosInstance from "../utils/AxiosInstance";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const fetchEmailTemplates = async () => {
    try {
        const response = await axiosInstance.get(`${BASE_URL}/etemplate/`);
        return response.data;
    } catch (error) {
        console.error("Template fetch failed:", error);
        throw error;
    }
};

export const fetchEmailTemplateById = async (templateId) => {
    try {
        const response = await axiosInstance.get(`${BASE_URL}/etemplate/${templateId}`);
        return response.data;
    } catch (error) {
        console.error("Failed to fetch email template by ID:", error);
        throw error;
    }
};

export const updateEmailTemplate = async (templateId, templateData) => {
    try {
        const response = await axiosInstance.patch(`${BASE_URL}/etemplate/${templateId}`, templateData);
        console.log(response);
        return response.data;
    } catch (error) {
        console.error("Failed to update email template:", error);
        throw error;
    }
};
